import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FooterComponent } from './components/footer/footer.component';
import { PageNotFoundComponent } from './components/page-not-found/page-not-found.component';
import { CoreRoutingModule } from './core-routing.module';
import { NumberMaskingPipe } from './pipes/number-masking.pipe';
import { HeaderComponent } from './components/header/header.component';
import { DeviceProfileComponent } from '../deviceprofile/deviceprofile.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TimerComponent } from '../timer/timer.component';
import { NgDompurifyModule } from '@tinkoff/ng-dompurify';

@NgModule({
	declarations: [
		HeaderComponent,
		FooterComponent,
		PageNotFoundComponent,
		NumberMaskingPipe,
		DeviceProfileComponent,
		TimerComponent
	],
	imports: [
		CommonModule,
		CoreRoutingModule,
		FormsModule,
		ReactiveFormsModule,
		NgDompurifyModule
	],
	providers: [
	],
	exports: [
		HeaderComponent,
		FooterComponent,
		PageNotFoundComponent,
		NumberMaskingPipe,
		DeviceProfileComponent,
		TimerComponent,
		NgDompurifyModule
	]
})
export class CoreModule { }
